// eslint-disable-next-line jira/import-whitelist
import {
	ATLASSIAN_CONSENT_COOKIE_KEY,
	ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY,
	ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY,
	type ConsentHubResponse,
	type PrefetchedConsentPreferenceData,
} from '@atlassian/browser-storage-controls';
// eslint-disable-next-line jira/import-whitelist
import { getCookie } from '@atlassian/jira-browser-storage-controls/src/utils/get-cookie/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { createResource, useResource } from '@atlassian/react-resource-router';
import {
	CONSENT_BANNER_USER_PREFERENCES,
	CONSENT_BANNER_USER_PREFERENCES_KEY,
} from './constants.tsx';

export const consentBannerUserPreferencesResource = createResource<PrefetchedConsentPreferenceData>(
	{
		type: CONSENT_BANNER_USER_PREFERENCES,
		getKey: () => CONSENT_BANNER_USER_PREFERENCES_KEY,
		getData: async () => {
			const consentToken = getCookie(ATLASSIAN_CONSENT_COOKIE_KEY);
			const fallbackConsentToken = getCookie(ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY);

			// If we have cached cookie data, bundle it up, with a potential fallback token
			if (fg('jfp-magma-browser-storage-bump-3')) {
				if (consentToken) {
					return { consentToken, fallbackConsentToken };
				}
			} else {
				const currentLocale = getCookie(ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY);
				if (consentToken && currentLocale) {
					return { consentToken, currentLocale, fallbackConsentToken };
				}
			}

			const data = await performGetRequest<ConsentHubResponse>(
				'/gateway/api/consenthub/session/user/consents/cookies',
			);
			return data;
		},

		maxAge: 15 * 60 * 1000,
		isBrowserOnly: true,
	},
);

export const useConsentBannerUserPreferencesResource = () =>
	useResource(consentBannerUserPreferencesResource);
